import itemSchema from '@/store/modules/schemas/default.schema'
import ModuleBase from '@/store/modules/ModuleBase'
import axios from '@ps_main/axios.js'
import requestManager from '@/utils/requestManager'

const resourceName = 'surveys'
const base = ModuleBase(itemSchema, resourceName)
export default {
  namespaced: base.namespaced,
  state: {
    ...base.state,
    countSurveyAttacksAppsNeedReview: 0,
    currentSupplierId: null
  },
  getters: {
    ...base.getters,
    getSurveyById: state => surveyId => {
      const survey = state.all.filter(s => parseInt(s.id) === parseInt(surveyId))
      if (survey.length) return survey[0]
      return null
    },
    countSurveyAttacksAppsNeedReview: state => state.countSurveyAttacksAppsNeedReview,
    getCurrentSupplierId: state => state.currentSupplierId
  },
  mutations: {
    ...base.mutations,
    SET_COUNT_SURVEY_ATTACKS_NEED_REVIEW (state, count) {
      state.countSurveyAttacksAppsNeedReview = count
    },
    SET_CURRENT_SUPPLIER_ID (state, id) {
      state.currentSupplierId = id
    }
  },
  actions: {
    ...base.actions,
    getSurveyById: async ({commit}, requestData) => {
      const withStr = requestData.params.with.replace(/ /g, '').replace(/(?:\r\n|\r|\n)/g, '')
      const withCountStr = requestData.params.withCount.replace(/ /g, '').replace(/(?:\r\n|\r|\n)/g, '')
      const res = await axios.get(`${base.basePath + resourceName  }/${  requestData.id}`,
        {
          params: {
            with: withStr,
            withCount: withCountStr
          }
        })
      const item = res.status === 200 && res.data ? res.data : null
      if (!item) return null
      //find item in list state and update it
      await commit('UPSERT', item)
      return item
    },
    getStatisticsData: async ({commit}, surveyId) => {
      const res = await axios.get(`${base.basePath + resourceName  }/${  surveyId}`)
      return res.status === 200 && res.data ? res.data : null
    },
    getSurveyAttacksAppsNotReviewedCount: async ({commit}) => {
      const requestKey = 'survey_attacks_apps_not_reviewed_count'
      
      return await requestManager.execute(requestKey, async () => {
        const url = `${base.basePath}survey-attacks-apps/count-not-reviewed`
        const res = await axios.get(url)
        const count = res.data ? res.data.count : 0
        commit('SET_COUNT_SURVEY_ATTACKS_NEED_REVIEW', count)
        return res.data
      })
    }
  }
}
